import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M11.01 7.452a1.167 1.167 0 0 1 1.649 0l.681.681-.224.341a.406.406 0 0 0 .065.506c.13.13.31.154.449.096l.056-.032.34-.224.689.69a1.167 1.167 0 0 1 0 1.649l-3.557 3.556a1.167 1.167 0 0 1-1.65 0l-.686-.686.218-.339a.406.406 0 0 0-.067-.502.406.406 0 0 0-.502-.068l-.339.219-.68-.681a1.167 1.167 0 0 1 0-1.65zm.942.707a.167.167 0 0 0-.236 0L8.16 11.715a.167.167 0 0 0 0 .236l.158.158c.472-.125.995.005 1.363.372.367.368.496.89.37 1.362l.165.165a.17.17 0 0 0 .236 0l3.557-3.556a.167.167 0 0 0 0-.236l-.162-.161a1.42 1.42 0 0 1-1.372-.368c-.37-.37-.5-.9-.369-1.374z",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M10.667 1.5a.5.5 0 0 1 .5.5v.833h2.166c.645 0 1.167.523 1.167 1.167v1.333a.5.5 0 0 1-1 0V4a.167.167 0 0 0-.167-.167h-2.166v.834a.5.5 0 0 1-1 0v-.834H5.833v.834a.5.5 0 1 1-1 0v-.834H2.667A.167.167 0 0 0 2.5 4v8.667c0 .092.075.166.167.166h2.666a.5.5 0 0 1 0 1H2.667A1.167 1.167 0 0 1 1.5 12.667V4c0-.644.522-1.167 1.167-1.167h2.166V2a.5.5 0 0 1 1 0v.833h4.334V2a.5.5 0 0 1 .5-.5"
    }, null, -1)
  ])))
}
export default { render: render }